import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLoader } from "@fortawesome/pro-duotone-svg-icons";
import { useState, useEffect } from "react";

//https://www.reddit.com/r/reactjs/comments/l2yz8h/comment/gkakifs/?utm_source=share&utm_medium=web2x&context=3
export const useImageExists = (src: string, alt: string, srcClassName: string, fallbackSrc: string, fallbackClassName: string, loadingIndicatorColor: string): React.ReactElement => {
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const onError = () => {
        setError(true);
        setIsLoading(false);
    };

    const onImageLoad = () => {
        setIsLoading(false);
    }

    const getLoadingIndicatorColor = (): string => {
        if (loadingIndicatorColor != null && loadingIndicatorColor !== "" && loadingIndicatorColor !== "#") {
            return loadingIndicatorColor;
        }
        else {
            return '#9CB560';
        }
    }

    useEffect(() => {
        if (src == null || src === '' || src === '#') {
            onError();
        }
    }, [src]);

    return error === true ?
        <img src={fallbackSrc} alt={alt} className={fallbackClassName} /> :
        <>
            <FontAwesomeIcon className="srcClassName" icon={faLoader} size="lg" color={getLoadingIndicatorColor()} spin pulse style={{ display: isLoading === true ? 'block' : 'none' }} title='Loading Image...' />
            <img src={src} alt={alt} onError={onError} className={srcClassName} style={{ display: isLoading === true ? 'none' : 'block' }} onLoad={onImageLoad} />
        </>;
}